import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import HorizontalShear from './horizontalshear';

// Breadcrumbs Background Image

const Reliable = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <Header
                navImg={navImg1}
                parentMenu='reliable-roof-repair'
                activeMenu="/reliable-roof-repair"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="Horizontal Automatic Container Shearing Machine"
                pageName="Horizontal Automatic Container Shearing Machine"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <HorizontalShear />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default Reliable;